import normalizer from '@cordel/helpers/form/schema';

// eslint-disable-next-line import/no-extraneous-dependencies
import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';

import {
  DENIED,
  NEUTRAL,
  APPROVED,
  TITLES,
  IDENTIFIERS,
} from '@sdk/views/Simulations/Read/status';

import {
  FILTERS,
  ALWAYS_VISIBLE,
} from './sections';

import {
  SEARCH,
  SELLER_ID,
  STORE_ID,
  BANK_CODE,
  STATUS,
  SORT,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [FILTERS]: {},
    },

    fields: {
      [SEARCH]: {
        section: FILTERS,
        subsection: ALWAYS_VISIBLE,
        type: 'input',
        label: 'Pesquisar',
        labelless: true,
        placeholder: 'Pesquisar...',
        size: 9,
        icon: 'search',
      },
      [STORE_ID]: {
        section: FILTERS,
        subsection: ALWAYS_VISIBLE,
        type: 'select',
        label: 'Loja',
        labelless: true,
        placeholder: 'Filtrar por loja',
        size: 3,
      },
      [SELLER_ID]: {
        section: FILTERS,
        type: 'select',
        label: 'Vendedor',
        labelless: true,
        placeholder: 'Filtrar por vendedor',
        size: 3,
      },
      [BANK_CODE]: {
        section: FILTERS,
        type: 'select',
        label: 'Banco',
        labelless: true,
        placeholder: 'Filtrar por banco',
        size: 3,
      },
      [STATUS]: {
        section: FILTERS,
        type: 'select',
        label: 'Status',
        labelless: true,
        placeholder: 'Filtrar por status',
        size: 3,
        options: [APPROVED, NEUTRAL, DENIED]
          .map(item => ({
            label: TITLES[item],
            value: String(IDENTIFIERS[item]),
          })),
      },
      [SORT]: {
        section: FILTERS,
        type: 'select',
        label: 'Ordenação',
        labelless: true,
        placeholder: 'Ordenação dos resultados',
        size: 3,
        options: Object.values(SORT_METHODS),
        value: SORT_METHODS.created_at_desc.value,
      },
    },
  });
}
